import React, { useEffect, useState } from 'react';
import { useOutletContext, Link } from 'react-router-dom';
import { Car, TrendingUp, ShoppingCart, Plus } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { dealerDashboard } from '../../services/dealerApi';
import PlanInfoCard from '../../components/dealers/PlanInfoCard';

const StatCard = ({ icon: Icon, label, value, accent = 'cyan', testid }) => (
  <div data-testid={testid} className="relative bg-slate-900/40 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-5 hover:border-cyan-500/40 transition-colors duration-300 overflow-hidden">
    <div className={`absolute -top-12 -right-12 w-32 h-32 rounded-full bg-${accent}-500/10 blur-2xl pointer-events-none`} />
    <div className="relative flex items-start justify-between">
      <div>
        <div className="text-xs uppercase tracking-[0.18em] text-slate-400 font-medium">{label}</div>
        <div className="mt-3 text-3xl font-extrabold text-white tracking-tight">{value}</div>
      </div>
      <div className={`w-10 h-10 rounded-xl bg-${accent}-500/10 border border-${accent}-500/20 flex items-center justify-center`}>
        <Icon className={`w-5 h-5 text-${accent}-400`} strokeWidth={1.75} />
      </div>
    </div>
  </div>
);

const DealerDashboard = () => {
  const { dealer } = useOutletContext();
  const [summary, setSummary] = useState({ active_listings: 0, cars_sold: 0, drafts: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dealerDashboard.summary()
      .then((res) => setSummary(res.summary))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="dealer-dashboard" className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <span className="text-xs uppercase tracking-[0.2em] text-cyan-400 font-medium">Dashboard</span>
          <h1 className="mt-1 text-3xl md:text-4xl font-extrabold text-white tracking-tight">Welcome back, {dealer?.name?.split(' ')[0] || 'Dealer'}</h1>
          <p className="mt-1 text-slate-400 text-sm">Quick overview of your dealership</p>
        </div>
        <Link to="/dealers/add-car">
          <Button data-testid="dashboard-add-car-btn" className="bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold rounded-xl shadow-[0_0_15px_rgba(6,182,212,0.25)]">
            <Plus className="w-4 h-4 mr-2" /> Add New Car
          </Button>
        </Link>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard icon={Car} label="Active Listings" value={loading ? '—' : summary.active_listings} testid="stat-active" />
        <StatCard icon={ShoppingCart} label="Cars Sold" value={loading ? '—' : summary.cars_sold} accent="green" testid="stat-sold" />
        <StatCard icon={TrendingUp} label="Drafts" value={loading ? '—' : summary.drafts} accent="orange" testid="stat-drafts" />
      </div>

      {/* Plan Info */}
      <PlanInfoCard />
    </div>
  );
};

export default DealerDashboard;
